import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

/**
 * Scrolls the window to the top whenever the pathname changes.
 * Mount once at the top of the router. Prevents the "click a footer link → land
 * at the bottom of the destination page" foot-gun that made the Free Invoice
 * Generator footer link look broken.
 */
const ScrollToTop = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    // Behave like a real page navigation: jump to the top, no smooth scroll.
    window.scrollTo(0, 0);
  }, [pathname]);

  return null;
};

export default ScrollToTop;
